import { timerHelperModule } from '../timer-helper';

const IDLE_AFTER_MINUTES = 15;
const IDLE_CHECK_RATE_SECONDS = 30;
const ACTIVE_EVENTS = [
  'mousemove',
  'mousedown',
  'touchstart',
  'click',
  'keydown',
  'scroll',
];

export const idleDetectionHelperModule = angular
  .module('Q.helpers.idle-detection-helper', [timerHelperModule])

  .run(function ($rootScope, $document, timerHelper) {
    let wasIdle = false;
    let idleCount = 0;
    const maxIdleCount = (IDLE_AFTER_MINUTES * 60) / IDLE_CHECK_RATE_SECONDS;

    // On every activity event we reset the number of idle counts
    ACTIVE_EVENTS.forEach((event) => {
      $document[0].addEventListener(
        event,
        () => {
          idleCount = 0;
          if (wasIdle) {
            wasIdle = false;
            // notify listeners that we're no longer idle
            $rootScope.$broadcast('idleDetection', false);
          }
        },
        true,
      );
    });

    // On every TIMER_DELAY tick, we increment the idle counts. If we get over our max,
    // we broadcast an event
    timerHelper.runEvery(() => {
      idleCount++;
      if (!wasIdle && idleCount >= maxIdleCount) {
        wasIdle = true;
        // notify listeners that we've gone idle
        $rootScope.$broadcast('idleDetection', true);
      }
    }, IDLE_CHECK_RATE_SECONDS * 1000);
  });
